/* Metaobject gallery — renders the selected root album, navigates into child
   albums via URL hash, and shows photos in a lightbox.

   Click rules:
   - Click any album card (child) → render that album's view (title, description,
     sub-albums, photos).
   - Click any photo thumbnail inside a view → open the lightbox at that photo.
   - Back button → return to the root album. */
(function () {
  function init(root) {
    var dataScript = root.querySelector('[data-albums-data]');
    if (!dataScript) return;

    var parsed;
    try {
      parsed = JSON.parse(dataScript.textContent);
    } catch (err) {
      console.warn('[gm-gallery] Could not parse album data', err);
      return;
    }

    var albums = parsed.albums || [];
    var byHandle = {};
    albums.forEach(function (a) { byHandle[a.handle] = a; });

    var rootHandle = root.getAttribute('data-root-handle') || '';
    var titleEl = root.querySelector('[data-title]');
    var descEl = root.querySelector('[data-description]');
    var childSection = root.querySelector('[data-child-section]');
    var childGrid = root.querySelector('[data-child-grid]');
    var photosSection = root.querySelector('[data-photos-section]');
    var photoGrid = root.querySelector('[data-photo-grid]');
    var backBtn = root.querySelector('[data-back]');

    var lightbox = root.querySelector('[data-lightbox]');
    var lbImage = root.querySelector('[data-lightbox-image]');
    var lbCounter = root.querySelector('[data-lightbox-counter]');
    var lbClose = root.querySelector('[data-lightbox-close]');
    var lbPrev = root.querySelector('[data-lightbox-prev]');
    var lbNext = root.querySelector('[data-lightbox-next]');

    var currentPhotos = [];
    var currentIndex = 0;

    /* ---------- routing ---------- */

    function readHash() {
      var m = (window.location.hash || '').match(/album=([^&]+)/);
      return m ? decodeURIComponent(m[1]) : '';
    }

    function navigateTo(handle) {
      var newHash = handle ? ('#album=' + encodeURIComponent(handle)) : '';
      var url = window.location.pathname + window.location.search + newHash;
      if (history.pushState) {
        history.pushState(null, '', url);
        applyRoute();
      } else {
        window.location.hash = newHash;
      }
    }

    function applyRoute() {
      var handle = readHash();
      if (!handle || handle === rootHandle) {
        renderAlbum(rootHandle, false);
      } else {
        renderAlbum(handle, true);
      }
    }

    /* ---------- render an album into the view ---------- */

    function renderAlbum(handle, isChild) {
      var album = byHandle[handle];
      if (!album) {
        renderAlbum(rootHandle, false);
        return;
      }

      if (titleEl) titleEl.textContent = album.title || handle;

      if (descEl) {
        if (album.description) {
          descEl.innerHTML = album.description;
          descEl.hidden = false;
        } else {
          descEl.innerHTML = '';
          descEl.hidden = true;
        }
      }

      /* Sub-albums */
      if (childGrid) childGrid.innerHTML = '';
      var childHandles = album.child_handles || [];
      if (childHandles.length > 0) {
        if (childSection) childSection.hidden = false;
        childHandles.forEach(function (h) {
          var child = byHandle[h];
          if (!child) return;
          childGrid.appendChild(buildCard(child));
        });
      } else {
        if (childSection) childSection.hidden = true;
      }

      /* Photos */
      if (photoGrid) photoGrid.innerHTML = '';
      var photos = album.photos || [];
      if (photos.length > 0) {
        if (photosSection) photosSection.hidden = false;
        photos.forEach(function (photo, idx) {
          photoGrid.appendChild(buildPhotoThumb(photo, idx, photos));
        });
      } else {
        if (photosSection) photosSection.hidden = true;
      }

      if (backBtn) backBtn.hidden = !isChild;

      try { window.scrollTo({ top: root.offsetTop - 40, behavior: 'instant' }); }
      catch (e) { window.scrollTo(0, Math.max(root.offsetTop - 40, 0)); }
    }

    function buildCard(album) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gm-gma__card';
      btn.setAttribute('data-album-handle', album.handle);
      btn.setAttribute('aria-label', album.title || album.handle);

      var imgWrap = document.createElement('span');
      imgWrap.className = 'gm-gma__image';
      if (album.cover) {
        var img = document.createElement('img');
        img.src = album.cover;
        img.alt = album.cover_alt || album.title || '';
        img.loading = 'lazy';
        imgWrap.appendChild(img);
      }
      btn.appendChild(imgWrap);

      var text = document.createElement('span');
      text.className = 'gm-gma__card-text';
      var t = document.createElement('span');
      t.className = 'gm-gma__card-title';
      t.textContent = album.title || album.handle;
      text.appendChild(t);

      var photoCount = (album.photos || []).length;
      var childCount = (album.child_handles || []).length;
      var metaParts = [];
      if (photoCount > 0) metaParts.push(photoCount + ' photos');
      if (childCount > 0) metaParts.push(childCount + ' albums');
      if (metaParts.length > 0) {
        var m = document.createElement('span');
        m.className = 'gm-gma__card-meta';
        m.textContent = metaParts.join(', ');
        text.appendChild(m);
      }
      btn.appendChild(text);

      bindCard(btn);
      return btn;
    }

    function buildPhotoThumb(photo, idx, allPhotos) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gm-gma__photo-thumb';
      btn.setAttribute('aria-label', 'Open photo ' + (idx + 1));
      var img = document.createElement('img');
      img.src = photo.thumb || photo.full;
      img.alt = photo.alt || '';
      img.loading = 'lazy';
      btn.appendChild(img);
      btn.addEventListener('click', function () {
        openLightbox(allPhotos, idx);
      });
      return btn;
    }

    /* ---------- click bindings ---------- */

    function bindCard(card) {
      card.addEventListener('click', function (e) {
        e.preventDefault();
        var handle = card.getAttribute('data-album-handle');
        if (!handle) return;
        navigateTo(handle);
      });
    }

    /* Bind server-rendered child cards (the root view's cards) */
    root.querySelectorAll('[data-album-handle]').forEach(bindCard);

    /* Bind server-rendered photo thumbs (the root view's photos) */
    if (rootHandle && byHandle[rootHandle]) {
      var rootPhotos = byHandle[rootHandle].photos || [];
      root.querySelectorAll('[data-photo-index]').forEach(function (btn) {
        var idx = parseInt(btn.getAttribute('data-photo-index'), 10) || 0;
        btn.addEventListener('click', function () {
          openLightbox(rootPhotos, idx);
        });
      });
    }

    if (backBtn) {
      backBtn.addEventListener('click', function () {
        navigateTo('');
      });
    }

    /* ---------- lightbox ---------- */

    function openLightbox(photos, idx) {
      if (!photos || photos.length === 0) return;
      currentPhotos = photos;
      currentIndex = idx || 0;
      renderLightbox();
      if (lightbox) lightbox.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      if (lbClose) lbClose.focus();
      document.addEventListener('keydown', onKey);
    }

    function closeLightbox() {
      if (lightbox) lightbox.hidden = true;
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      currentPhotos = [];
    }

    function renderLightbox() {
      if (!currentPhotos.length || !lbImage) return;
      var photo = currentPhotos[currentIndex];
      lbImage.src = photo.full || photo.thumb;
      lbImage.alt = photo.alt || '';
      if (lbCounter) {
        lbCounter.textContent = (currentIndex + 1) + ' / ' + currentPhotos.length;
      }
    }

    function nextPhoto() {
      if (!currentPhotos.length) return;
      currentIndex = (currentIndex + 1) % currentPhotos.length;
      renderLightbox();
    }

    function prevPhoto() {
      if (!currentPhotos.length) return;
      currentIndex = (currentIndex - 1 + currentPhotos.length) % currentPhotos.length;
      renderLightbox();
    }

    function onKey(e) {
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowRight') nextPhoto();
      else if (e.key === 'ArrowLeft') prevPhoto();
    }

    if (lbClose) lbClose.addEventListener('click', closeLightbox);
    if (lbNext) lbNext.addEventListener('click', nextPhoto);
    if (lbPrev) lbPrev.addEventListener('click', prevPhoto);
    if (lightbox) {
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeLightbox();
      });
    }

    /* ---------- bootstrap ---------- */

    window.addEventListener('popstate', applyRoute);

    /* On initial load: if URL hash points to a non-root album, render it.
       Otherwise the server-rendered root view stays as-is. */
    var initialHash = readHash();
    if (initialHash && initialHash !== rootHandle && byHandle[initialHash]) {
      renderAlbum(initialHash, true);
    }
  }

  function bootstrap() {
    document.querySelectorAll('[data-gm-gallery]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
